import React from "react";
import { Sidebar } from "primereact/sidebar";
// router
import { Navigate, Route, Routes } from "react-router-dom";
// pages
import ChatPage from "../pages/misc/ChatPage";
import HomePage from "../pages/misc/HomePage";
import ProfilePage from "../pages/profile/ProfilePage";
import SearchPage from "../pages/search/SearchPage";
import UserPostsPage from "../pages/misc/UserPostsPage";
import PostDetailsPage from "../pages/misc/PostDetailsPage";
import TopSearch from "../pages/search/TopSearch";
import Policy from "../pages/search/Policy";
import GeneralUpdate from "../pages/search/GeneralUpdate";
import Opportunity from "../pages/search/Opportunity";
import Users from "../pages/search/Users";

// navbar
import { useSelector } from "react-redux";
import Navbar from "../components/nav/Navbar";
import SideLeft from "../components/nav/SideLeft";
import SideMenu from "../components/nav/SideMenu";
import { defaultImage } from "../constants/IMAGES";

export default function AppRouter() {
  const userState = useSelector((state) => state.user);
  const [menu, setMenu] = React.useState(false);
  return (
    <div className="transition-ease-in-out transition-duration-500 bg-gray-100 ">
      <Navbar showMenu={() => setMenu(true)} />
      <div
        className="h-screen grid w-full grid-nogutter overflow-hidden"
        style={{
          paddingTop: 60,
        }}
      >
        <SideLeft />
        <div className="bg-gray-100 col">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="profile/:id" element={<ProfilePage />} />
            <Route path="search" element={<SearchPage />}>
              <Route path="top" element={<TopSearch />} />
              <Route path="users" element={<Users />} />
              <Route path="general-update" element={<GeneralUpdate />} />
              <Route path="policy" element={<Policy />} />
              <Route path="opportunity" element={<Opportunity />} />
            </Route>
            <Route path="post/:id" element={<PostDetailsPage />} />
            <Route path="posts/:id" element={<UserPostsPage />} />
            <Route path="chat" element={<ChatPage />} />

            {/* default redirect */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </div>

      {/* menu show for small screen*/}
      <Sidebar
        visible={menu}
        onHide={() => setMenu(false)}
        showCloseIcon={false}
      >
        <div className="h-screen">
          <SideMenu hideMenu={() => setMenu(false)} />
        </div>
      </Sidebar>
    </div>
  );
}
